import { useTranslation } from 'react-i18next'
import CannibalizationModel from './CannibalizationModel'
import CannibalizationController from './CannibalizationController'
import { Box, Button, Grid2, MenuItem, Select, Typography } from '@mui/material'
import { extractRootDomain } from '../../../utils/Utils'
import * as React from 'react'
import PaperItem from '../../../components/Essential/PaperItem'
import Filter from '../../../components/Filter/Filter'
import { FILTER_CLICKS, FILTER_CTR, FILTER_POSITIONS, FILTER_VOLUME } from '../../../utils/Constants'
import DateRangeSelectorView from '../../../components/Selectors/DateRangeSelector/DateRangeSelectorView'
import TableComponent from '../../../components/TableComponent'
import ButtonExportExcel from '../../../components/Buttons/ExportExcel'
import { COLUMNS_PROJECT_CANNIBALIZATION } from '../../../utils/TableColumnsConstants'


const CannibalizationView = () => {
  const { t } = useTranslation()

  const model = CannibalizationModel()
  const controller = CannibalizationController(model)

  return (
    <Grid2 container spacing={2} className='container-analysis'>
      <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
        <PaperItem className='flex-col gap-2 boxShadow' sx={{ p: 3 }}>

          <Select variant={'outlined'} value={model.projectSelected || ''}
                  onChange={(event) => {
                    model.setProjectSelected(event.target.value)
                  }}
                  displayEmpty
                  fullWidth
                  className={'projectSelector'}
                  MenuProps={{ disableScrollLock: true }}
          >
            <MenuItem value="" disabled style={{ display: 'none' }} >{t('project')}</MenuItem>

            {model.projectsData && (
              model.projectsData
                .sort((a, b) => extractRootDomain(a.property).localeCompare(extractRootDomain(b.property)))
                .map((item) => {
                  return (
                    <MenuItem key={item.id} value={item.property}>
                      <img
                        src={`https://www.google.com/s2/favicons?sz=32&domain=${extractRootDomain(item.property) || 'example.com'}`}
                        loading="lazy"
                        alt="favicon"
                        width={20}
                        height={20}
                        style={{ borderRadius: '50%', marginRight: '10px', verticalAlign: 'bottom' }}
                      />
                      <span>{extractRootDomain(item.property)}</span>
                    </MenuItem>
                  );
                })
            )}
          </Select>

          <div className='flex gap-2 w-full pt-3' >
            { /*<KeywordsFilters />*/}
            <Filter name='clicks' items={FILTER_CLICKS} custom={true} onChange={controller.handleFilterUpdate} />
            <Filter name='impressions' items={FILTER_CLICKS} custom={true} onChange={controller.handleFilterUpdate} />
            <Filter name='position' items={FILTER_POSITIONS} custom={true} onChange={controller.handleFilterUpdate} />
            <Filter name='ctr' items={FILTER_CTR} custom={true} onChange={controller.handleFilterUpdate} />
            <DateRangeSelectorView onChange={controller.handleFilterUpdate} />
          </div>

          <div className="flex justify-end">
            <Button
              color="primary"
              variant="contained"
              onClick={controller.handleSearchBtn}
              disabled={!model.projectSelected}
            >
              {t('obtain')}
            </Button>
          </div>
        </PaperItem>
      </Grid2>

      <Grid2 size={12}>
        <PaperItem className="boxShadow" sx={{ p: 3 }}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={0}>
            <Typography className="mb-5">{t('organic_keywords')}</Typography>
            <ButtonExportExcel isLoading={model.isLoading.export} onClick={controller.handleExportExcel} totalKeywords={model.keywordsData?.length || 0} query={model.project || ""} />
          </Box>
          <TableComponent
            autoHeight
            rowHeight={140}
            rows={model.keywordsData}
            getRowHeight={() => 'auto'}
            loading={model.isLoading.keywords}
            columns={COLUMNS_PROJECT_CANNIBALIZATION(t)}
            paginationMode="client"
            sortingMode="client"
            initialState={{
              pagination: {
                paginationModel: { pageSize: 10, page: 0 }
              }
            }}
            pageSizeOptions={[10, 25, 50, 100]}
          />
        </PaperItem>
      </Grid2>

    </Grid2>
  )
}

export default CannibalizationView

/*import CannibalizationModel from './CannibalizationModel';
import CannibalizationController from './CannibalizationController';
import Grid from '@mui/material/Grid2';
import PaperItem from '../../../components/Essential/PaperItem';
import SelectorView from '../../../components/Projects/ProjectSelector/ProjectSelectorView';
import { useTranslation } from 'react-i18next';
import MenuSelector from '../../../components/MenuSelector';
import * as CONSTANTS from '../../../utils/Constants';
import { valuesSplitNumber, volumeOfSearchesOptions } from '../../../utils/Utils';
import CustomRange from '../../../components/CustomRange';
import DateRangeSelectorView from '../../../components/Selectors/DateRangeSelector/DateRangeSelectorView';
import { Box, Button, Typography } from '@mui/material';
import TableComponent from '../../../components/TableComponent';
import { COLUMNS_PROJECT_CANNIBALIZATION } from '../../../utils/TableColumnsConstants';
import ButtonExportExcel from '../../../components/Buttons/ExportExcel';

const CannibalizationView = () => {
  const { t } = useTranslation();

  const model = CannibalizationModel();
  const controller = CannibalizationController(model);

  return (
    <Grid container spacing={2} className="container-analysis">
      <Grid size={12}>
        <PaperItem className="boxShadow" sx={{ p: 3 }}>

          <SelectorView label={t('project')} project={model.project || ''} setProject={model.setProject}
                        itemList={model.dataProject} />

          <div className="flex gap-2 w-full items-end py-3">
            <MenuSelector
              value={model.clicksOfSearches}
              isSelected={model.hasClicksOfSearches}
              defaultValue={model.defaultValueClicks}
              suggestion={CONSTANTS.clicksOfSearchesOptions}
              onChange={(values) => model.handleClicksOfSearches(valuesSplitNumber(values.label))}>
              <CustomRange
                toValues={model.clicksOfSearches.to}
                fromValues={model.clicksOfSearches.from}
                onClick={(value) => model.handleClicksOfSearches(value)}
              />
            </MenuSelector>

            <MenuSelector
              value={model.impressionsOfSearches}
              defaultValue={model.defaultValueImpression}
              suggestion={volumeOfSearchesOptions}
              isSelected={model.hasImpressionsOfSearches}
              onChange={(values) => model.handleImpressionsOfSearches(valuesSplitNumber(values.label))}>
              <CustomRange
                toValues={model.impressionsOfSearches.to}
                fromValues={model.impressionsOfSearches.from}
                onClick={(value) => model.handleImpressionsOfSearches(value)}
              />
            </MenuSelector>

            <MenuSelector
              value={model.positionOfSearches}
              isSelected={model.hasPositionsOfSearches}
              defaultValue={model.defaultValuePositions}
              suggestion={CONSTANTS.potitionOfSearchesOptions}
              onChange={(values) => model.handlePositionOfSearches(valuesSplitNumber(values.label))}>
              <CustomRange
                toValues={model.positionOfSearches.to}
                fromValues={model.positionOfSearches.from}
                onClick={(value) => model.handlePositionOfSearches(value)}
              />
            </MenuSelector>

            <MenuSelector
              value={model.ctrOfSearches}
              isSelected={model.hasCtrOfSearches}
              defaultValue={model.defaultValueCtr}
              suggestion={CONSTANTS.CRTOfSearchesOptions}
              onChange={(values) => model.handleCtrOfSearches(valuesSplitNumber(values.label))}>
              <CustomRange
                toValues={model.ctrOfSearches.to}
                fromValues={model.ctrOfSearches.from}
                onClick={(value) => model.handleCtrOfSearches(value)}
              />
            </MenuSelector>

            <div className="flex">
              <DateRangeSelectorView onChange={model.handleChangeRanges} />
            </div>
          </div>
          <div className="flex justify-end">
            <Button
              color="primary"
              variant="contained"
              onClick={controller.getKeywords}
              disabled={!model.project.property || model.loadingCannibalization}>
              {t('obtain')}
            </Button>
          </div>
        </PaperItem>
      </Grid>

      <Grid size={12}>
        <PaperItem className="boxShadow" sx={{ p: 3 }}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={0}>
            <Typography className="mb-5">{t('organic_keywords')}</Typography>
            <ButtonExportExcel isLoading={model.isLoading} onClick={controller.handleExport} totalKeywords={model.dataCannibalization.length} query={model.project?.property || ""} />
          </Box>
          <TableComponent
            autoHeight
            rowHeight={140}
            rows={model.dataCannibalization}
            getRowHeight={() => 'auto'}
            loading={model.loadingCannibalization}
            columns={COLUMNS_PROJECT_CANNIBALIZATION(t)}
            paginationMode="client"
            sortingMode="client"
            initialState={{
              pagination: {
                paginationModel: { pageSize: 10, page: 0 }
              }
            }}
            pageSizeOptions={[10, 25, 50, 100]}
          />
        </PaperItem>
      </Grid>


    </Grid>
  );
};

export default CannibalizationView;

 */